import { Route } from "react-router-dom";
import ParentCategoryPackage from "../pages/parentCategory/ParentCategoryPackage";

export default (netsRoute) => {
  return [
    <Route
      exact
      path={`/${netsRoute}/:parentCategory/package/`}
      component={ParentCategoryPackage}
      key={`${netsRoute}parentCategoryPackageRoute`}
    />,
  ];
};
